import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, WhyChooseUs, Clients, Banner, Process, Products, PortfolioSection, NewsletterSection, Blogs, Menu } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Menu />
        <Services />
        <WhyChooseUs />
        <Products />
        <Counter />
        <Process />
        <Banner />
        <PortfolioSection />
        <Testimonials />
        <Team />
        <NewsletterSection />
        <Blogs />
        <Clients />

      </section>

    </>
  );
}

export default AboutUs;